export default __webpack_public_path__ + "static/media/carousel1.b68855c2.png";